import styled from '@emotion/styled';
import { columnShift } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RaceDetails/RaceDetails.style';
import { withConfig } from 'src/withConfig';

export const TableBodyRow = withConfig(theme => styled('div', { label: 'TableBodyRow' })`
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
    margin: 0;
    &:first-of-type {
        padding-top: 0;
    }
    &:last-of-type {
        border-bottom: 0;
        padding-bottom: 0;
    }
    @media ${theme.star.mediaQuery.tablet} {
        align-items: center;
    }
`);

export const TbodyCellFirst = styled('div', { label: 'TbodyCellFirst' })`
    padding: 4px 8px;
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 72px;
    width: 72px;
`;

export const TbodyRowWrapper = withConfig(theme => styled('div', { label: 'TbodyRowWrapper' })`
    flex: 1 1 auto;
    padding: 4px 8px;
    &:last-of-type {
        display: flex;
        flex-flow: column nowrap;
    }
    @media ${theme.star.mediaQuery.tablet} {
        padding: 0;
        justify-content: space-between;
        &:last-of-type {
            flex-direction: row;
        }
    }
`);

export const TbodyCell = withConfig(theme => styled('div', { label: 'TbodyCell' })`
    @media ${theme.star.mediaQuery.tablet} {
        padding: 4px 8px;
    }
`);

export const TbodyCellSummary = withConfig(theme => styled(TbodyCell, { label: 'TbodyCellSummary' })`
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 ${columnShift};
    }
`);

export const DetailsItem = withConfig(theme => styled('span', { label: 'DetailsItem' })`
    color: ${theme.star.raceCard.stats.txtColorTertiary};
    position: relative;
    &::after {
        content: '•';
        margin: 0 8px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`);

export const PositionWrapper = styled('b', { label: 'PositionWrapper' })`
    &::after {
        content: '/';
        margin: 0 4px;
    }
`;
